const common_error_en = {
    address: "Address is required",
    bank_acc: "Bank account is required",
    category: "Item category is required",
    customer: "Customer is required",
    date: "Date is required",
    date_due: "Due date is required",
    district: "District is required",
    email: "Email is required",
    email_valid: "Invalid email format",
    file: "File is required",
    name: "Name is required",
    payment_method: "Payment method is required",
    pass: "Password is required",
    pass_valid: "Invalid password format",
    pass_conf: "Password confirmation is required",
    pass_conf_match: "Passwords do not match",
    phone: "Phone number is required",
    province: "Province is required",
    sub_province: "City is required",
    sub_district: "Sub-district is required",
    supplier: "Supplier is required",

    login: "Invalid email or password",

    // transaction
    cost1_name: "Cost name is required",
    cost2_name: "Discount name is required",

    goods: "Item is required",
    goods_data: "Item data is required",
    goods_min: "At least 1 item is required",
    goods_qty_zero: "Item quantity cannot be 0",

    sn: "Serial number is required",
    sn_qty: "Quantity exceeds available stock",
    sn_same: "Duplicate serial number",
    sn_used: "Serial number already used",

    warehouse: "Warehouse is required",
    warehouse_min: "At least 1 warehouse is required",
    warehouse_orig: "Origin warehouse is required",
    warehouse_dest: "Destination warehouse is required",

    inv_data: "Invoice data is required",
    inv_min: "At least 1 invoice is required"
}

export default common_error_en;